import React from 'react';
import type { SignupFlow } from 'corgi-types';
import type { SpaceProps } from 'styled-system';

import { Button, type ButtonKind } from 'common/components/Button';
import { HeadlineH8 } from 'common/components/Typography';
import { useRegistrationURL } from 'common/hooks/urls';
import { useLocalization } from 'common/providers/LocaleProvider';
import { useRouter } from 'common/providers/RouterProvider';
import { Event } from 'common/types/auth';

interface CtaRegisterProps extends SpaceProps {
  userFlow: SignupFlow;
  kind?: ButtonKind;
  label?: string;
  withGuestLogin?: boolean;
  referredBy?: string;
  disabled?: boolean;
}

const CtaRegister = ({
  kind = 'primary',
  userFlow,
  label,
  withGuestLogin,
  referredBy,
  disabled,
  ...spaceProps
}: CtaRegisterProps) => {
  const router = useRouter();
  const { t } = useLocalization();
  const registrationUrl = useRegistrationURL({ userFlow, referredBy });

  const proceedButtonLabel =
    label ?? (withGuestLogin ? t('h24_create_new_customer_account') : t('h24_proceed'));

  return (
    <Button
      py="sp_12"
      kind={kind}
      onClick={() => router.push(registrationUrl)}
      tracking={{
        eventName: Event.LoginFormClick,
        text: proceedButtonLabel,
      }}
      disabled={disabled}
      {...spaceProps}
    >
      <HeadlineH8
        color={
          disabled
            ? 'sys.neutral.text.inactive'
            : kind === 'secondary-v2'
              ? 'sys.neutral.text.default'
              : 'sys.neutral.background.default'
        }
      >
        {proceedButtonLabel}
      </HeadlineH8>
    </Button>
  );
};

export default CtaRegister;
